var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 15.832 15.832",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    cx: 2.375,
    cy: 2.375,
    r: 2.375,
    transform: "translate(5.541 5.541)",
    fill: "#e42125"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2017",
    "data-name": "Path 2017",
    d: "M17.832,9.126H16.194A6.338,6.338,0,0,0,10.708,3.64V2H9.124V3.64A6.339,6.339,0,0,0,3.638,9.126H2V10.71H3.638A6.339,6.339,0,0,0,9.124,16.2v1.638h1.583V16.2a6.339,6.339,0,0,0,5.487-5.487h1.638V9.126ZM9.916,14.668a4.75,4.75,0,1,1,4.75-4.75A4.755,4.755,0,0,1,9.916,14.668Z",
    transform: "translate(-2 -2.002)",
    fill: "#e42125"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutline);
export default __webpack_public_path__ + "static/media/Outline.9a318ccc48d26ed634d55dabbd36766d.svg";
export { ForwardRef as ReactComponent };